// The merge's bookkeeping (05g-2): the pure part of main.js's mergeModules. It covers the
// names on the ⚡ charging screen, its markup, and the colour each new player gets. The
// animation itself is mergeModules in drop-actions.ts.

import { COMPARE_LETTERS } from "./drop-rules.js";

/** Who's on the charging screen: everyone already on the target, then the newcomer (by
 *  id; `shortName` turns each into the name shown). */
export function chargingNames<Id>(targetPlayers: readonly Id[], source: Id, shortName: (id: Id) => string): string[] {
  return targetPlayers.concat(source).map(shortName);
}

/** main.js's charging markup, character for character. Its whitespace becomes text nodes
 *  in the body, so a DOM comparison sees it. The names aren't escaped (as before). */
export function chargingHtml(names: readonly string[]): string {
  return `
      <div class="merge-charging">
        <div class="merge-charging-bolt">⚡</div>
        <div class="merge-charging-names">${names.join(" + ")}</div>
      </div>
    `;
}

/** A first merge: the target keeps colour a, the newcomer takes b. */
export const FIRST_PAIR_COLORS = ["a", "b"] as const;

/**
 * The colour for a player joining an existing comparison: the lowest letter not in use.
 * A slot someone freed by an unmerge is reused. The others keep theirs, because a colour
 * belongs to the player and is never reshuffled.
 */
export function nextCompareColor(used: readonly string[]): string {
  const inUse = new Set(used);
  const free = COMPARE_LETTERS.find((l) => !inUse.has(l));
  // The drop rules refuse a 6th player (MAX_COMPARE_PLAYERS), so a letter is always free.
  if (!free) throw new Error(`nextCompareColor: no colour left (in use: ${used.join(", ")})`);
  return free;
}
